// extracted by mini-css-extract-plugin
module.exports = {"faqs":"styles_faqs__sTLqw","faqs__title":"styles_faqs__title__EtuTE"};